import { z } from 'zod';
import { fileInputSchema } from '../../shared';
export const uploadPriceTrackFilesSchema = z.object({
    update_type: z.string().nonempty(),
    files: fileInputSchema,
});
